(function () {
	'use strict';

	angular.module('mx.shell').component('mxShellUserMenu', {
		bindings: { isMobile: '@' },
		controller: MxShellUserMenuCtrl,
		controllerAs: 'vm',
		templateUrl: 'components/mx-shell-user-menu/mx-shell-user-menu.html',
	});

	MxShellUserMenuCtrl.$inject = ['mx.shell.ToolbarManager', '$mdSidenav', '$scope'];

	function MxShellUserMenuCtrl(ToolbarManager, $mdSidenav, $scope) {
		var vm = this;

		vm.$onInit = function () {
			vm.ToolbarManager = ToolbarManager;
		};

		vm.processItemClick = function (item) {
			if (vm.isMobile) {
				$mdSidenav('mx-shell-left-sidebar').close();
			}
			item.onItemClick();
		};

		$scope.$on('$mdMenuOpen', function () {
			vm.__isOpened = true;
		});

		$scope.$on('$mdMenuClose', function () {
			setTimeout(function () {
				vm.__isOpened = false;
			}, 10);
		});
	}
})();
